import PropTypes from 'prop-types';
import * as React from 'react';
import ColumnSynchronizer from './ColumnSynchronizer';
import {columnSynchronizerPropType} from './propTypes';

export type Props = {
    children?: React.ReactNode,
}

export default class DataTableContext extends React.PureComponent<Props> {

    static propTypes = {
        children: PropTypes.node,
    };

    static childContextTypes = {
        columnSynchronizer: columnSynchronizerPropType,
    };

    props: Props;
    columnSynchronizer: ColumnSynchronizer = new ColumnSynchronizer();

    getChildContext(): { [string]: any } {
        return {
            columnSynchronizer: this.columnSynchronizer,
        };
    }

    render(): React.ReactNode {
        return this.props.children;
    }

}
